import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state:{
		ime_predmeta:{
			broj_predmeta:'',
			ime_stranke:'',
			ime_protustranke:''
		},
		paginacija:{
			title:'PSOD ERP',
			subpages:[],
			back_link:''
		},
		event_details:{
			popup_open:false,
			chosen_event:null,
			selected_day:null,
			selected_type:0,
		},
		chosen_date:null,
		chosen_type:1,
		notifies_shown:false,
		sioVar:null,
		vrsta_osobe:1,
		rocista_tab_active:false,
		rocista_report_data:{events:null,razdoblje:''},
		edit_data:null,
		project_task_progress:0,
		last_page_name:"",
		// currency_data:{
		// 	input_value:0,
		// 	drop_value:1,
		// },
		shared_input_value:'',
		predmeti_report_data:{
			all_predmeti: [],
			naslov: '',
			odvjetnik_nositelj:null,
			odvjetnik_name:''
		},
		spis_active_pic:null,
		spis_overlay_open:false,
		view_cases_by_logged_person:false,
		troskovnik_data:null,
		edit_troskovnik_data:null,
	}
});